import { call, put, takeLatest } from 'redux-saga/effects';
import { createFlashMessage } from '../components/Flash/redux';
import {
  getEmailDaylyMetrics,
  getEmailSentQuantity,
  fetchUpdateEmailStats
} from '../utils/api/admin';
import { actionTypes } from './action-types';

function* fetchEmailStats() {
  try {
    const data = yield call(getEmailDaylyMetrics);

    yield put({
      type: actionTypes.fetchEmailStatsComplete,
      payload: data
    });
  } catch (error) {
    console.error('Error fetching e-mail stats:', error);
    yield put({
      type: actionTypes.fetchEmailStatsError,
      payload: error
    });
    yield put(
      createFlashMessage({
        type: 'danger',
        message: 'Erro ao buscar métricas de e-mail. Tente novamente.',
        variables: { dismissible: true }
      })
    );
  }
}

function* fetchEmailSentQuantity() {
  try {
    const data = yield call(getEmailSentQuantity);

    yield put({
      type: actionTypes.fetchEmailSentQuantityComplete,
      payload: data
    });
  } catch (error) {
    console.error('Error fetching e-mail sent quantity:', error);
    yield put({
      type: actionTypes.fetchEmailSentQuantityError,
      payload: error
    });
    yield put(
      createFlashMessage({
        type: 'danger',
        message:
          'Erro ao buscar quantidade de e-mails enviados. Tente novamente.',
        variables: { dismissible: true }
      })
    );
  }
}

function* updateEmailStats() {
  try {
    const data = yield call(fetchUpdateEmailStats);

    if (!data.success) {
      throw new Error(data.message);
    }

    yield put({
      type: actionTypes.updateEmailStatsComplete
    });

    yield call(fetchEmailStats);
    yield call(fetchEmailSentQuantity);

    yield put(
      createFlashMessage({
        type: 'success',
        message: 'Dados atualizados com sucesso!',
        variables: { dismissible: true }
      })
    );
  } catch (error) {
    console.error('Error updating email stats:', error);
    yield put({
      type: actionTypes.updateEmailStatsError,
      payload: error
    });
    yield put(
      createFlashMessage({
        type: 'danger',
        message: 'Erro ao atualizar estatísticas de e-mail. Tente novamente.',
        variables: { dismissible: true }
      })
    );
  }
}

export function createEmailStatsSaga(types) {
  return [
    takeLatest(types.fetchEmailStats, fetchEmailStats),
    takeLatest(types.fetchEmailSentQuantity, fetchEmailSentQuantity),
    takeLatest(types.updateEmailStats, updateEmailStats)
  ];
}
